import React from 'react'
import { useDispatch } from 'react-redux'
import { setShouldAllowPendingRacingTicketCountPolling } from '@core/Areas/AppHeader/Store'
import { navigateToMyBets } from '@core/Areas/AppHeader/helpers/navigateToMyBets'
import { PendingTicketsCountProvider } from '@core/Data/Account/PendingTicketsCount/PendingTicketsCountProvider'
import { useFeature } from '@core/Utils/hooks/useFeature'
import type { DisplayLocation } from '../../types'
import { Button } from '../Common/Button'
import { useInvalidatePendingCountOnEvents } from './hooks'

export const PendingBetsButton = React.memo<{
  displayLocation: DisplayLocation
  isSportsRoute?: boolean
}>(({ displayLocation, isSportsRoute = false }) => {
  const dispatch = useDispatch()
  const isUnifiedMyBetsFeatureActive = useFeature('unified-my-bets-racing-sports')

  useInvalidatePendingCountOnEvents()

  // Reset polling state on unmount
  React.useEffect(() => {
    return () => {
      dispatch(setShouldAllowPendingRacingTicketCountPolling(true))
    }
  }, [dispatch])

  return (
    <PendingTicketsCountProvider
      render={({
        pendingBetsCount,
        pendingSportsCount,
        pendingRacingCount,
        isRacingLoading,
        isRacingError,
        isKambiLoading,
        isKambiError,
      }) => {
        const handleClick = () => {
          const isSportsOnlyPending =
            isSportsRoute || (!!pendingSportsCount && pendingRacingCount === 0)

          navigateToMyBets({
            pendingBetsCount,
            isSportsOnlyPending,
            displayLocation,
            tab: 'pending',
            isUnifiedMyBetsFeatureActive,
          })
        }

        if (isKambiError && isRacingError) return null

        return (
          <Button
            type='pending'
            displayLocation={displayLocation}
            count={isRacingLoading || isKambiLoading ? null : pendingBetsCount}
            onClick={handleClick}
          />
        )
      }}
    />
  )
})

PendingBetsButton.displayName = 'PendingBetsButton'
